const handleServiceError = (error) => {
  if (error.response) {
    console.log(error.response.status);
    console.log(error.response.headers);
  } else if (error.request) {
    console.log(error.request);
  } else {
    console.log('Error', error.message);
  }
  console.log(error.config);
  throw (error.response.data);
};

export default {
  handleServiceError,
};
